import React, { useEffect, useContext, useState } from 'react';
import { appContext } from "./../../../AppContext";
import {useFetch} from '../../../utils/hooks/useFetch'
import { Spin, message, List, Avatar, Tag} from 'antd';
import AddCharacterModal from './AddCharacterModal';
import CharacterModal from './CharacterModal';
import { charactersColumn } from '../columns/characterColumns';
import LarpTable from '../../table/LarpTable';
import { useHistory } from "react-router-dom";
import { CloseCircleOutlined, CheckCircleOutlined, InfoCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons'

export default function PlayerCharacters({
    characterTypes,
    characterStatusses,
    races
}) {

     const [appState] = useContext(appContext);
     const [doFetch, FetchType] = useFetch();
     const[isLoading, setIsLoading] = useState(true)
     const [searchValue, setSearchValue] = useState("");
     const [dataSource, setDataSource] = useState([]);
     const [listSource, setListSource] = useState([]);
     const [result, setResult] = useState([])
     const [isAddModalVisible, setIsAddModalVisible] = useState(false);
     const [isModalVisible, setIsModalVisible] = useState(false);
     const [selectedRecord, setSelectedRecord] = useState(undefined);
     const history = useHistory();
     const [unReadComments, setUnReadComments] = useState([])

      useEffect(() => {
        if(result.length <= 0) {
          setDataSource([]);
          setListSource([]);
          return;
        }

        const newDataSource = result.filter(_ => 
            (_.name === null && searchValue === "" ) || _.name?.toLowerCase().includes(searchValue.toLowerCase())
        )
        setDataSource(newDataSource);

        setListSource(newDataSource.map(_ => {
          return (
                  <List.Item
                      onClick={() => history.push(`/${appState.appName}/character?id=${_.id}`)}
                  >
                    <List.Item.Meta
                      avatar={<Avatar>{_.characterType.name}</Avatar>}
                      title={_.name}
                      description={_.shortDescription}
                    />
                    {getStatus(_.characterStatus)}
                  </List.Item>
          )
        }))

        function getStatus(status) {
          switch(status?.name) {
            case "Rejected":
              return (
                <Tag icon={<CloseCircleOutlined />} color="error">
                    {status?.name}
                </Tag>
              )
            case "Accepted by SL":
              return (
                <Tag icon={<CheckCircleOutlined />} color="success">
                    {status?.name}
                </Tag>
              )
            case "Review for SL":
              return (
                <Tag icon={<ExclamationCircleOutlined />} color="warning">
                    {status?.name}
                </Tag>
              )
            case "Changed after Accepted":
                return (
                    <Tag icon={<InfoCircleOutlined />} color="default">
                        {status?.name}
                    </Tag>
                )
            default:
              return null;
        }
        }
      }, // eslint-disable-next-line
      [result, searchValue])

      useEffect(() => {
        refresh();
          }, // eslint-disable-next-line
      [searchValue, appState.storyId])

      function refresh()
      {
          const url = `/api/character/GetMy`
          doFetch(url)
          .then((response) => onCharactersLoaded(response.isSuccess, response.result))
  
          function onCharactersLoaded(isSuccess, result) { 
            if(isSuccess) {
              setResult(result);
              setIsLoading(false);


              setSelectedRecord(result.find(_ => _.id === selectedRecord?.id))

              return;
            }
            setResult([])
            message.error('Could not get characters');
            setIsLoading(false);
          }

          const url2 = `/api/comment/character/getUnseenList`
          doFetch(url2)
          .then((response) => onUnseenLoaded(response.isSuccess, response.result))
  
          function onUnseenLoaded(isSuccess, result) { 
            if(isSuccess) {
              setUnReadComments(result)
              return;
            }
            setUnReadComments([])
          }
      }

      if(isLoading)
      {
          return <Spin />
      }

      function onDelete(record)
      {
          const url = `/api/character/delete/${record.id}`
          doFetch(url, FetchType.DELETE, null)
              .then((response) => onRemove(response.isSuccess))
  
          function onRemove(isSuccess) {

            if(isSuccess) {
              message.success('The character has been removed');
              refresh()
              return;
            }
            message.error('Could not remove Character');
          }
      }

      function onRowClick(record)
      {
        history.push(`/${appState.appName}/character?id=${record.id}`)
      }

      const columns = charactersColumn(characterTypes, races, onRowClick, onDelete, appState, unReadComments)

    return (
      <>
        <LarpTable 
          columns={columns}
          dataSource={dataSource}
          listSource={listSource}
          onDoubleRowClick={onRowClick}
          setSearchValue={setSearchValue}
          refresh={refresh}
          setIsAddModalVisible={setIsAddModalVisible}
          addLabel="Add Character"
        />

        <CharacterModal 
          refresh={refresh}
          setIsModalVisible={setIsModalVisible}
          isModalVisible={isModalVisible}
          characterTypes={characterTypes}
          characterStatusses={characterStatusses}
          races={races}
          originalCharacter={selectedRecord}
        />      

        <AddCharacterModal 
          refresh={refresh}
          setIsModalVisible={setIsAddModalVisible}
          isModalVisible={isAddModalVisible}
          characterTypes={characterTypes}
          races={races}
        />      
      </>
    )
}